<template>
  <div id="view">
    <van-dialog v-model="show" :showConfirmButton="false">
      <div class="dots">
        <div></div>
        <div></div>
        <div></div>
      </div>
    </van-dialog>
  </div>

</template>
<script>
export default {
  props: {
    show: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {}
  },
  methods: {
    errView() {
      this.$emit('data-sent', this.show);
    },
  }
}
</script>
<style scoped lang="less">
#view {
  .dots {
    width: 2.4rem;
    display: flex;
    flex-flow: row nowrap;
    align-items: center;
    justify-content: space-between;
  }

  .dots div {
    width: .6rem;
    height: .6rem;
    border-radius: 50%;
    background-color: #fff;
    animation: fade 0.8s ease-in-out alternate infinite;
  }

  .dots div:nth-of-type(1) {
    animation-delay: -0.4s;
  }

  .dots div:nth-of-type(2) {
    animation-delay: -0.2s;
  }

  @keyframes fade {
    from {
      opacity: 1;
    }
    to {
      opacity: 0;
    }
  }

  ::v-deep {
    .van-overlay {
      background-color: rgba(0, 0, 0, 0.7);
    }
    .van-dialog {
      background-color: transparent;
    }

    .van-dialog__content {
      //height: 3rem;
      padding: 1rem 0;
      border: none;
      display: flex;
      justify-content: center;
    }
  }
}
</style>
